"use client";

import { useState, useEffect } from "react";
import { Box, Flex, Tabs, TabList, Tab, Spinner, useColorModeValue } from "@chakra-ui/react";
import axios from "axios";

// ECharts migration — the echarts versions handle both the "All" view and a
// selected region via the optional `region` prop. Old Chart.js versions kept
// at ./Chart4(.Region) etc. for instant revert.
import Chart4 from "../echarts/Chart4";
import Chart5 from "../echarts/Chart5";
import Chart6 from "../echarts/Chart6";

const ChkRegionTabs = ({ supplier, retailer, contentCardProps, keyStr }) => {
  const [regions, setRegions] = useState([]);
  const [loadingRegions, setLoadingRegions] = useState(true);
  const [selectedRegion, setSelectedRegion] = useState(null); // null = "All"

  const activeBg = useColorModeValue("blue.50", "blue.900");
  const activeColor = useColorModeValue("blue.600", "blue.200");

  useEffect(() => {
    setLoadingRegions(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/rep_sales/chk_regions`, {
        userid: localStorage.getItem("userid"),
      })
      .then((res) => {
        const data = res.data?.data || [];
        setRegions(data.map((r) => r.region));
      })
      .catch((err) => console.error("ChkRegionTabs fetch regions", err))
      .finally(() => setLoadingRegions(false));
  }, []);

  const handleTabChange = (index) => {
    if (index === 0) {
      setSelectedRegion(null);
    } else {
      setSelectedRegion(regions[index - 1]);
    }
  };

  if (loadingRegions) {
    return (
      <Flex justify="center" align="center" py={8}>
        <Spinner size="md" color="blue.400" />
      </Flex>
    );
  }

  const chartOverflowCss = { "& > div": { overflow: "visible !important" }, "& canvas": { maxWidth: "none !important" } };

  const chartKey = selectedRegion ? `${keyStr}-${selectedRegion}` : keyStr;

  return (
    <Box>
      {/* Region Tab Bar */}
      <Tabs
        index={selectedRegion ? regions.indexOf(selectedRegion) + 1 : 0}
        onChange={handleTabChange}
        variant="soft-rounded"
        size="sm"
        mb={4}
      >
        <TabList flexWrap="wrap" gap={1}>
          <Tab
            _selected={{ bg: activeBg, color: activeColor, fontWeight: "semibold" }}
            fontSize="xs"
            px={3}
            py={1}
          >
            All
          </Tab>
          {regions.map((r) => (
            <Tab
              key={r}
              _selected={{ bg: activeBg, color: activeColor, fontWeight: "semibold" }}
              fontSize="xs"
              px={3}
              py={1}
            >
              {r}
            </Tab>
          ))}
        </TabList>
      </Tabs>

      {/* Charts: Chart4 + Chart5 + Chart6 */}
      <Flex direction={{ base: "column", lg: "row" }} wrap="wrap" gap={4}>
        <Box flex="1" minW="300px" height="350px" p={4} {...contentCardProps} overflow="visible" css={chartOverflowCss}>
          {selectedRegion ? (
            <Chart4 key={`c4r-${chartKey}`} supplier={supplier} retailer={retailer} region={selectedRegion} />
          ) : (
            <Chart4 key={`c4-${chartKey}`} supplier={supplier} retailer={retailer} />
          )}
        </Box>
        <Box flex="1" minW="300px" height="350px" p={4} {...contentCardProps} overflow="visible" css={chartOverflowCss}>
          {selectedRegion ? (
            <Chart5 key={`c5r-${chartKey}`} supplier={supplier} retailer={retailer} region={selectedRegion} />
          ) : (
            <Chart5 key={`c5-${chartKey}`} supplier={supplier} retailer={retailer} />
          )}
        </Box>
        <Box flex="1" minW="300px" height="350px" p={4} {...contentCardProps} overflow="visible" css={chartOverflowCss}>
          {selectedRegion ? (
            <Chart6 key={`c6r-${chartKey}`} supplier={supplier} retailer={retailer} region={selectedRegion} />
          ) : (
            <Chart6 key={`c6-${chartKey}`} supplier={supplier} retailer={retailer} />
          )}
        </Box>
      </Flex>
    </Box>
  );
};

export default ChkRegionTabs;
